import { gql } from 'apollo-boost';

export const allowedBidModifiersValuesFragment = gql`
    fragment allowedBidModifiersValuesFragment on GdAllowedBidModifierValues {
        type
        maxConditions
        percentRange {
            max
            min
            step
        }
        ... on GdAllowedBidModifierValuesMobile {
            osTypes
        }

        ... on GdAllowedBidModifierValuesInventory {
            inventoryTypes
        }

        ... on GdAllowedBidModifierValuesAdType {
            adTypes
        }
    }
`;
